import React from "react";
import { Building2, Star, UserCog } from "lucide-react";

export const orgSummary = (o) => (o ? `${o.employee_count} موظف · ${o.branch_count} فرع` : "—");

const EmployeeChip = ({ e }) => (
  <span className={`inline-flex items-center gap-1 text-xs rounded-full px-2 py-0.5 border ${e.is_active ? "bg-white border-[#DCEBEE] text-[#333333]" : "bg-gray-50 border-gray-200 text-[#888888]"}`} data-testid={`org-employee-${e.id}`}>
    <span className="font-bold">{e.name}</span>
    <span className={e.designation === "branch_manager" ? "text-[#088395] font-bold" : "text-[#777777]"}>· {e.designation_ar}</span>
    {!e.is_active && <span>· غير نشط</span>}
  </span>
);

const BranchBlock = ({ b, merchantId }) => (
  <div className="rounded-lg border border-[#DCEBEE] bg-[#F5FAFB] p-3 min-w-0" data-testid={`org-branch-${merchantId}-${b.id || "main"}`}>
    <div className="flex items-center gap-2 flex-wrap text-sm">
      <Building2 size={14} className="text-[#09637E] shrink-0" />
      <span className="font-extrabold text-[#333333]">{b.name}</span>
      {b.is_main && <span className="inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded-full bg-[#09637E] text-white" data-testid="org-main-badge"><Star size={10} /> الفرع الرئيسي</span>}
      <span className="text-xs text-[#666666] tabular-nums">{b.employee_count} موظف</span>
    </div>
    {b.employees.length > 0 && <div className="flex flex-wrap gap-1.5 mt-2">{b.employees.map((e) => <EmployeeChip key={e.id} e={e} />)}</div>}
  </div>
);

export default function MerchantOrgPanel({ org, merchantId }) {
  if (!org) return null;
  return (
    <div className="space-y-2" data-testid="merchant-org-panel">
      <div className="flex items-center gap-2 text-sm font-extrabold text-[#333333] flex-wrap">
        <UserCog size={16} className="text-[#09637E]" /> الموظفون والفروع
        <span className="text-xs text-[#666666] font-bold tabular-nums" data-testid="org-summary">{orgSummary(org)}</span>
        <span className="text-[10px] text-[#888888]">(عرض فقط)</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {org.branches.map((b) => <BranchBlock key={b.id || "main"} b={b} merchantId={merchantId} />)}
      </div>
      {org.employee_count === 0 && <div className="text-xs text-[#888888]">لا يوجد موظفون لهذا التاجر</div>}
    </div>
  );
}
